import '../shared/analytics.js'
import { createApp } from 'vue'
import App from './App.vue'
import AuthFloatingControls from './AuthFloatingControls.vue'
import { initSentry } from '../shared/sentry.js'

function mountFloatingControls() {
  // Always mount a floating top-right theme toggle on auth pages.
  const anchor = document.createElement('div')
  anchor.id = 'auth-floating-anchor'
  document.body.appendChild(anchor)
  createApp(AuthFloatingControls).mount(anchor)
}

function mountAuthApp() {
  const target = document.getElementById('auth-app')
  if (!target) return
  const app = createApp(App)
  initSentry(app, { entry: 'auth' })
  app.mount(target)
}

function init() {
  mountFloatingControls()
  mountAuthApp()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
